module.exports = __webpack_public_path__ + "static/tools_01-560x320-9e4d4c635489542947ea9344d7eaf1d4.jpg";